export default __webpack_public_path__ + "static/media/cop7.8c6bb1ea.png";